exports.DomainTypes = {
  STAGING: 'staging',
  PROD: 'prod'
};